// extracted by mini-css-extract-plugin
export default {"workContainer":"my-work-print_workContainer_NFlLn","workImage":"my-work-print_workImage_woTuP"};